/**
 * @generated SignedSource<<f5fa58aa2ed6a9a417f5c159610f8c41>>
 * @relayHash c36b285fc9ddbfa16f8915e905d46039
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 98c82b74cbf83920337381141c785c3c3d9fbe86204fea8c40171518e7584e6a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "98c82b74cbf83920337381141c785c3c3d9fbe86204fea8c40171518e7584e6a",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
